<template>
    <div v-if="companyName" style="padding-top: 92px">
        <div class="success-line flex flex-center">
          <div class="iconfont icon-corrent_ico1"></div>
          <p>申请提交完成！</p>
        </div>
        <p class="tips">您的加入申请已提交，请耐心等待企业管理员审核</p>
        
        <div class="primary-btn" @click="gologin">好的</div>
    </div>
    <div class="regbox" v-else style="padding-top: 125px">
        <div class="success-line flex flex-center" style="margin-bottom: 90px">
            <div class="iconfont icon-corrent_ico1"></div>
            <p>注册完成！</p>
        </div>
        <div class="primary-btn" @click="goindex">立即进入 {{time}}s</div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      from: "",
      companyName: "",
      adminName: "",
      adminPhone: "",
      time: 5,
      timer: null
    };
  },
  created() {
    let query = this.$route.query;
    if (query && query.kscompyname && query.ksadname && query.ksadminPhone) {
      this.companyName = query.kscompyname ? decodeURI(query.kscompyname) : '';
      this.adminName = query.ksadname ? decodeURI(query.ksadname) : '';
      this.adminPhone = query.ksadminPhone;
    } else {
      this.timer = setInterval(() => {
        this.time -= 1;
        if (this.time < 0) {
          this.goindex()
          clearInterval(this.timer)
        }
      }, 1000)
    }
  },
  methods: {
    goindex() {
      this.$router.push({
        path: "/index/home/index"
      });
    },
    gologin(){
      this.$router.push({
        path: "/login"
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import url('../../assets/less/base.less');
.success-line{
  font-size: 32px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 22px;
}
.tips{
  font-size: 20px;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
  margin-bottom: 108px;
}
.iconfont{
  font-size: 40px;
  color: @color-primary;
  margin-right: 40px;
}
.primary-btn{
  height: 40px;
  line-height: 40px;
  width: 150px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// regsuc.vue?1a32a8cd